import { api } from './client';

export type AutomationEvent = 'ticket.created' | 'ticket.updated' | 'message.added';

export interface AutomationCondition {
  field: string;
  op: string;
  value: string | number | boolean | string[] | null;
}

export interface AutomationAction {
  type: string;
  payload: Record<string, unknown>;
}

export interface AutomationRule {
  id: string;
  name: string;
  description?: string | null;
  event: AutomationEvent;
  enabled: boolean;
  conditions: AutomationCondition[];
  actions: AutomationAction[];
  priority: number;
  stop_on_match: boolean;
  matched_count: number;
  created_at: string;
  updated_at: string;
  updated_by?: string | null;
}

export type RuleInput = Omit<AutomationRule,
  'id' | 'matched_count' | 'created_at' | 'updated_at' | 'updated_by'>;

export const automationApi = {
  list: () => api.get<AutomationRule[]>('/api/v1/automation/rules').then(r => r.data),
  create: (data: RuleInput) =>
    api.post<AutomationRule>('/api/v1/automation/rules', data).then(r => r.data),
  update: (id: string, data: RuleInput) =>
    api.put<AutomationRule>(`/api/v1/automation/rules/${id}`, data).then(r => r.data),
  delete: (id: string) =>
    api.delete(`/api/v1/automation/rules/${id}`).then(r => r.data),
};
